import React from "react";
import CustomSlider from "./CustomSlider";
import MakerFilter from "./MakerFilter";
import KeiFilter from "./KeiFilter";
import TextSearch from "./TextSearch";
import PowerFilter from "./PowerFilter";
import "./style.css";
// import HaikiryoCustomSlider from "./HaikiryoCustomSlider";
import NensikiCustomSlider from "./NensikiCustomSlider";
import KyoriCustomSlider from "./KyoriCustomSlider";

const Sideber = ({
  ucarData,
  setUcarData,
  ucarSerchData,
  setUcarSerchData,
  sliderValue,
  setSliderValue,
  iniSliderValue,
  kyoriSliderValue,
  setKyoriSliderValue,
  iniKyoriSliderValue,
  haikiryoSliderValue,
  setHaikiryoSliderValue,
  iniHaikiryoSliderValue,
  nensikiSliderValue,
  setNensikiSliderValue,
  iniNensikiSliderValue,
  makerChecked,
  setMakerChecked,
  keiChecked,
  setKeiChecked,
  powerChecked,
  setPowerChecked,
  kudoChecked,
  setKudoChecked,
  serchInput,
  setSerchInput,
}) => {
  return (
    <div className='sidebar'>
      <TextSearch searchInput={serchInput} setSearchInput={setSerchInput} />
      <CustomSlider
        sliderValue={sliderValue}
        setSliderValue={setSliderValue}
        iniSliderValue={iniSliderValue}
      />
      <KyoriCustomSlider
        kyoriSliderValue={kyoriSliderValue}
        setKyoriSliderValue={setKyoriSliderValue}
        iniKyoriSliderValue={iniKyoriSliderValue}
      />
      {/* <HaikiryoCustomSlider
        haikiryoSliderValue={haikiryoSliderValue}
        setHaikiryoSliderValue={setHaikiryoSliderValue}
        iniHaikiryoSliderValue={iniHaikiryoSliderValue}
      /> */}
      <NensikiCustomSlider
        nensikiSliderValue={nensikiSliderValue}
        setNensikiSliderValue={setNensikiSliderValue}
        iniNensikiSliderValue={iniNensikiSliderValue}
      />
      <MakerFilter
        ucarData={ucarData}
        setUcarData={setUcarData}
        ucarSerchData={ucarSerchData}
        setUcarSerchData={setUcarSerchData}
        sliderValue={sliderValue}
        setSliderValue={setSliderValue}
        iniSliderValue={iniSliderValue}
        makerChecked={makerChecked}
        keiChecked={keiChecked}
        setMakerChecked={setMakerChecked}
      />
      <KeiFilter
        ucarData={ucarData}
        setUcarData={setUcarData}
        ucarSerchData={ucarSerchData}
        setUcarSerchData={setUcarSerchData}
        sliderValue={sliderValue}
        setSliderValue={setSliderValue}
        iniSliderValue={iniSliderValue}
        makerChecked={makerChecked}
        keiChecked={keiChecked}
        setMakerChecked={setMakerChecked}
        setKeiChecked={setKeiChecked}
      />
      <PowerFilter
        powerChecked={powerChecked}
        setPowerChecked={setPowerChecked}
        kudoChecked={kudoChecked}
        setKudoChecked={setKudoChecked}
      />
    </div>
  );
};

export default Sideber;
